export const SetValuesProps = (formik: any, name: string) => ({
  values: formik.values[name],
  setValues: formik.setFieldValue,
  onBlur: formik.handleBlur,
  error: formik.touched[name] ? formik.errors[name] : undefined,
})
